import React from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Control,
  actions
} from 'react-redux-form';
// import { capitalize } from '../helpers'
import Errors from './Errors'
import {
  remove_column,
  reset_entry_errors
 } from '../actions'

const mapStateToProps = state => {
  return {
    removing_column: state.entry.removing_column,
    errors: state.entry.errors
  }
}

const mapDispatchToProps = dispatch => {
  return {
    removeColumn: (report_id, key) => dispatch( remove_column(report_id, key) ),
    resetForm: () => dispatch( actions.reset('removeColumn') ),
    resetErrors: () => dispatch ( reset_entry_errors() )
  }
}

class ConnectedRemoveColumn extends React.Component {
  constructor() {
    super()
    this.state = {
      selector: null
    }
  }

  handleSubmit(values) {
    const { report_id, removeColumn } = this.props;
    const { key } = values;
    console.log("VALUES")
    console.log(values)
    const value = (key === "") ? document.getElementById('removeItem').value : key
    removeColumn(report_id, value)
    // hide()
    // resetForm()
  }

  componentDidMount() {
    const elem = document.getElementById('removeItem')
    const selector = window.M.FormSelect.init(elem);
    this.setState({selector: selector})
  }

  componentDidUpdate(prevProps, prevState) {
    const { columns, removing_column, hide, resetForm, resetErrors, isHidden } = this.props
    const prevColumns = prevProps.columns
    const prevRemovingColumn = prevProps.removing_column
    const wasHidden = prevProps.isHidden

    if (isHidden && !wasHidden) {
      resetForm()
      resetErrors()
    } else {

      if ( JSON.stringify(columns) !== JSON.stringify(prevColumns) ) {
        const fs = this.state.selector
        fs.destroy()
        const elem = document.getElementById('removeItem')
        const selector = window.M.FormSelect.init(elem);
        this.setState({selector: selector})
      }
      if ( removing_column !== prevRemovingColumn ) {
        if ( prevRemovingColumn ) {
          hide()
          resetForm()
          resetErrors()
        }
      }

    }

  }

  componentWillUnmount() {
    const { resetForm, resetErrors } = this.props
    resetForm()
    resetErrors()
  }

  resetForm() {
    const { resetForm, resetErrors } = this.props
    resetForm()
    resetErrors()
  }

  render() {
    const { columns, isHidden, hide } = this.props
    // const fixed = ["sku","title","link","description","price","sale_price","condition","availability","id","title_length","image_link"]
    const fixed = ["address"]
    return(
      <Form
        model="removeColumn"
        className={isHidden ? 'hide' : ''}
        onSubmit = { (values) => {
          this.handleSubmit(values)
        }}
      >
        <div className="section">
          <div className="input-field">
            <label htmlFor="removeItem" className="active">Select a column to remove from Report. This column can be recovered, with its data, by adding it again.</label>
            <Control.select id="removeItem" model= "removeColumn.key">
              {
                columns.filter( column => fixed.indexOf(column.key) < 0 ).map( (column, index) => {
                  return(
                    <option value={column.key} key={index}>{column.name}</option>
                  )
                })
              }
            </Control.select>
          </div>
        </div>

        <Errors errors={this.props.errors} />

        <div className="section">
          <button className="btn red darken-1 waves-effect waves-light mr-10" onClick={(e)=>{
            e.preventDefault()
            hide()
            this.resetForm()
          }}>Cancel</button>
          <button type="submit" className="btn red darken-1 waves-effect waves-light"><i className="material-icons right">navigate_next</i>REMOVE COLUMN</button>
        </div>

      </Form>
    )

  }
}

const RemoveColumn = connect(mapStateToProps, mapDispatchToProps)(ConnectedRemoveColumn)

export default RemoveColumn



// WEBPACK FOOTER //
// ./src/js/components/RemoveColumn.js